import React, { useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
export const ModalChiTiet = (props) => {
  return (
    <Modal
      {...props}
      size="modal-xl modal-xl"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      className="modal-new modal fade text-left popup-detail"
    >
      <Modal.Header>
        <h4 className="modal-title  color7-bold" id="myModalLabel16">
          <span className="btn-icon-right">
            <i className="mdi mdi-card-account-details"></i>
          </span>
          Chi tiết nhân viên
        </h4>
        <button
          type="button"
          className="close-popup-new"
          onClick={props.onHide}
        >
          <img src="/app-assets/images/icon-dong-popup-v2.png" />
        </button>
      </Modal.Header>
      <Modal.Body>
        <form className="form tat-toan form-horizontal">
          <div className="form-body">
            <div className="card collapse-icon accordion-icon-rotate">
              <div
                id="headingCollapse25322"
                className="card-header border-info"
                href="#collapse25322"
                aria-expanded="true"
                aria-controls="collapse25322"
              >
                <a
                  className="card-title lead info collapsed"
                  href={() => false}
                >
                  <h3>Chi tiết nhân viên</h3>
                </a>
              </div>
              <div className="card-collapse collapse show">
                <div className="card-content">
                  <div className="card-body">
                    <div className="form-body form-bordered-1">
                      <div className="form-group row">
                        <label
                          className="col-md-3 label-control"
                          for="projectinput1"
                        >
                          Tên nhân viên
                        </label>
                        <div className="col-md-9">{props.tenNhanVien}</div>
                      </div>

                      <div className="form-group row ">
                        <label
                          className="col-md-3 label-control"
                          for="projectinput1"
                        >
                          Ngày sinh
                        </label>
                        <div className="col-md-9">{props.ngaySinh}</div>
                      </div>

                      <div className="form-group row ">
                        <label
                          className="col-md-3 label-control"
                          for="projectinput1"
                        >
                          Giới tính
                        </label>
                        <div className="col-md-9">
                          {props.gioiTinh === 1
                            ? "Nam"
                            : props.gioiTinh === 2
                            ? "Nữ"
                            : ""}
                        </div>
                      </div>

                      <div className="form-group row ">
                        <label
                          className="col-md-3 label-control"
                          for="projectinput1"
                        >
                          Số CCCD
                        </label>
                        <div className="col-md-9">{props.cMTND}</div>
                      </div>

                      <div className="form-group row">
                        <label
                          className="col-md-3 label-control"
                          for="projectinput1"
                        >
                          Địa chỉ
                        </label>
                        <div className="col-md-9">{props.diaChi}</div>
                      </div>

                      <div className="form-group row">
                        <label
                          className="col-md-3 label-control"
                          for="projectinput1"
                        >
                          Số điện thoại
                        </label>
                        <div className="col-md-9">{props.phoneNumber}</div>
                      </div>

                      <div className="form-group row">
                        <label
                          className="col-md-3 label-control"
                          for="projectinput1"
                        >
                          Email đăng nhập
                        </label>
                        <div className="col-md-9">{props.emailDangNhap}</div>
                      </div>

                      <div className="form-group row">
                        <label
                          className="col-md-3 label-control"
                          for="projectinput1"
                        >
                          Quyền
                        </label>
                        <div className="col-md-9">
                          {props.quyenChu === "shopadmin"
                            ? "Chủ"
                            : props.quyenChu === "shopmanager"
                            ? "Quản lý"
                            : props.quyenChu === "shopuser"
                            ? "Nhân viên"
                            : props.quyenChu === "shopreset"
                            ? "Reset Data"
                            : ""}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
      </Modal.Body>
      <Modal.Footer className="modal-footer button-popup-new-size">
        <a
          className="btn btn-new-main btn-closenew"
          data-dismiss="modal"
          href={() => false}
          onClick={props.onHide}
        >
          <span className="btn-icon-left">
            <i className="mdi mdi-close"></i>
          </span>
          Đóng
        </a>
      </Modal.Footer>
    </Modal>
  );
};
